const questions = {
    "pages": [{
		"number": 1,
		"title": "What is your Personality Type?",
        "header": "In order to develop your personalized individualized Newtopia plan and match you with your Inspirator, we need to know a bit more about your past experiences and way of thinking about your nutrition and exercise choices.\nPlease answer the following questions as honestly as you can.",
		"questions": [{
				"key": "motivated",
				"type": "radio",
				"text": "How often do you find it hard to stay motivated to follow a new healthy lifestyle plan for the time it takes to reach your goal?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "motivated_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "motivated_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "motivated_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "motivated_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "motivated_always"
					}
				]
			},
			{
				"key": "resist",
				"type": "radio",
				"text": "When following a healthy living plan, how often do you find you are resistant to changing your eating and/or exercise habits?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "resist_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "resist_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "resist_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "resist_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "resist_always"
					}
				]
			},
			{
				"key": "discouraged",
				"type": "radio",
				"text": "How often do you get discouraged or fall off track when following a new healthy eating or exercise plan?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "discouraged_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "discouraged_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "discouraged_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "discouraged_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "discouraged_always"
					}
				]
			},
			{
				"key": "exercising",
				"type": "radio",
				"text": "How often do you feel that eating well and exercising is just too much work or is just too hard?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "exercising_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "exercising_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "exercising_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "exercising_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "exercising_always"
					}
				]
			},
			{
				"key": "tempting",
				"type": "radio",
				"text": "If you fall off your healthy living plan (e.g., miss a planned work out, or overindulge), how often do you think: \"Well, I’ve blown it now, what’s the point?\", or \"Whatever... I’ll just get back on track Monday\"?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "tempting_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "tempting_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "tempting_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "tempting_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "tempting_always"
					}
				]
			},
			{
				"key": "track",
				"type": "radio",
				"text": "How often do you find it hard to get back on track if you’ve fallen off a healthy eating or exercise plan?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "track_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "track_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "track_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "track_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "track_always"
					}
				]
			},
			{
				"key": "snacking",
				"type": "radio",
				"text": "How often do you find yourself eating or snacking even though you are not physically hungry?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "snacking_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "snacking_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "snacking_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "snacking_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "snacking_always"
					}
				]
			},
			{
				"key": "large",
				"type": "radio",
				"text": "How often do you find you eat mindlessly, such that you are unaware of what, or how much you have eaten?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "large_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "large_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "large_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "large_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "large_always"
					}
				]
			},
			{
				"key": "quick",
				"type": "radio",
				"text": "How often do you find you gulp down food quickly and/or end up being the first person to finish a meal compared to others?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "quick_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "quick_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "quick_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "quick_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "quick_always"
					}
				]
			},
			{
				"key": "tv",
				"type": "radio",
				"text": "How often do you eat “on the go” (e.g., in your car, walking), or when standing up, working or watching TV?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "tv_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "tv_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "tv_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "tv_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "tv_always"
					}
				]
			},
			{
				"key": "full",
				"type": "radio",
				"text": "How often do you feel uncomfortably full after a meal?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "full_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "full_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "full_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "full_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "full_always"
					}
				]
			},
			{
				"key": "resist-foods",
				"type": "radio",
				"text": "How often do you find it hard to follow your healthy eating plan when you are out with friends, at a restaurant, or some other social function?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "resist-foods_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "resist-foods_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "resist-foods_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "resist-foods_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "resist-foods_always"
					}
				]
			},
			{
				"key": "alcohol",
				"type": "radio",
				"text": "How often do you eat (or drink alcohol) in response to negative emotions like anger, anxiety, loneliness or boredom?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "alcohol_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "alcohol_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "alcohol_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "alcohol_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "alcohol_always"
					}
				]
			},
			{
				"key": "stress",
				"type": "radio",
				"text": "How often do you eat (or drink alcohol) in response to stress or feeling overwhelmed with the demands of work and/or home?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "stress_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "stress_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "stress_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "stress_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "stress_always"
					}
				]
			},
			{
				"key": "fat-sugar-salt",
				"type": "radio",
				"text": "How often do you reach for foods that are high in fat, sugar or salt (e.g., chips, cookies, or chocolate) when you are feeling stressed, upset, or bored?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "fat-sugar-salt_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "fat-sugar-salt_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "fat-sugar-salt_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "fat-sugar-salt_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "fat-sugar-salt_always"
					}
				]
			},
			{
				"key": "reward",
				"type": "radio",
				"text": "How often do you overeat (or drink alcohol) as a reward or in celebration (e.g., overindulging to celebrate a special event or accomplishment, or for getting through a hard day)?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "reward_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "reward_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "reward_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "reward_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "reward_always"
					}
				]
			},
			{
				"key": "feel-about-yourself",
				"type": "radio",
				"text": "How often does the way you feel about yourself affect your motivation to follow a healthy lifestyle plan (e.g., exercising and eating well)?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "feel-about-yourself_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "feel-about-yourself_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "feel-about-yourself_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "feel-about-yourself_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "feel-about-yourself_always"
					}
				]
			},
			{
				"key": "favorite",
				"type": "radio",
				"text": "How often do you have trouble following a healthy eating plan when your favorite foods are in the house?",
				"options": {
					"noBR": false,
					"visible": true
				},
				"validation": {
					"required": true,
					"rqerror": "A value is required."
				},
				"fields": [{
						"index": 0,
						"text": "Never",
						"value": "never",
						"id": "never",
						"upsertKey": "favorite_never"
					},
					{
						"index": 1,
						"text": "Rarely",
						"value": "rarely",
						"id": "rarely",
						"upsertKey": "favorite_rarely"
					},
					{
						"index": 2,
						"text": "Sometimes",
						"value": "sometimes",
						"id": "sometimes",
						"upsertKey": "favorite_sometimes"
					},
					{
						"index": 3,
						"text": "Often",
						"value": "often",
						"id": "often",
						"upsertKey": "favorite_often"
					},
					{
						"index": 4,
						"text": "Always",
						"value": "always",
						"id": "always",
						"upsertKey": "favorite_always"
					}
				]
			}
		]
	}]
}
export default questions